import React from 'react';
import styled from 'styled-components';
import { connect } from "react-redux";
import { Imglist } from './../constants/ImagesList';
import { Link } from 'react-router-dom';
import Choose from './../features/choose';
import Rank from './../features/rank';
import { InGameMenu } from './../features/InGame';
import { setValues } from '../store/redux';
import { setValues as setModalValues } from '../features/modal/redux';
import { LoadingModal, MessageModal, RuleModal, RewardsModal, ConfirmModal, SuccessModal} from '../features/modal';

class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 'join',
            allowJoin: false
        };
    }
    componentDidMount = () => {
        this.componentDidUpdate()
    }

    componentDidUpdate = (prevProps) => {
        if (!this.props.loading && this.props.userData && this.props.userInfo.userProfile.manager_name === '') {
            this.props.setModalValues({
                modal_open: 'loading'
            })
            this.setState({
                page: ''
            })
            this.apiGetInfo()
        }
    }
    apiGetInfo() {
        if (this.props.loading) return;
        this.props.setValues({
            loading: true
        })

        fetch(process.env.REACT_APP_API_SERVER_HOST + process.env.REACT_APP_API_MAIN, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.userData.jwtToken
            },
            body: JSON.stringify({
                service: 'getInfo'
            })
        }).then(response => response.json()).then(response => {
            if (!response.status) {
                throw new Error(response.message)
            }
            // console.log(response.data);
            this.props.setValues({
                loading: false,
                userInfo: response.data
            })
            if(response.data.userProfile.team!==null){
                this.setState({
                    page: 'rank'
                })
            }
            else
            {
                this.setState({
                    page: 'join',
                    allowJoin: true
                })
            }
            this.props.setModalValues({
                modal_open: ''
            })

        }).catch(error => {
            console.log('API Error : ', error)
            this.props.setModalValues({
                modal_open: 'message',
                modal_message: error.message || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง'
            })
            this.setState({
                page: 'join',
                allowJoin: false
            })
        })
    }
    apiChoose() {
        if (this.props.loading) return;
        this.props.setValues({
            loading: true
        })
        this.props.setModalValues({
            modal_open: 'loading'
        })
        if(!this.props.userData){
            this.props.setModalValues({
                modal_open: 'message',
                modal_message: 'กรุณาล็อกอิน'
            })
            this.props.setValues({
                loading: false
            })
        }
        else
        {
            fetch(process.env.REACT_APP_API_SERVER_HOST + process.env.REACT_APP_API_MAIN, {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this.props.userData.jwtToken
                },
                body: JSON.stringify({
                    service: 'selectTeam',
                    team: this.props.modal_color,
                })
            }).then(response => response.json()).then(response => {
                if (!response.status) {
                    throw new Error(response.message)
                }
               
                this.props.setValues({
                    loading: false,
                    userInfo: {
                        ...this.props.userInfo,
                        ...response.data
                    }
                })
                this.setState({
                    page: 'rank'
                })
                this.props.setModalValues({
                    modal_open: 'success'
                })
    
            }).catch(error => {
                console.log('API Error : ', error)
                this.props.setModalValues({
                    modal_open: 'message',
                    modal_message: error.message || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง'
                })
            })
        }
    }

    handleJoin(color){
        this.props.setModalValues({
            modal_open: 'confirm',
            modal_color: color
        })
    }
    handleConfirm(){
        this.props.setModalValues({
            modal_open: 'success'
        })
    }
    handleDetail(){
        this.props.setModalValues({
            modal_open: 'rule'
        })
    }
    handleReward(){
        this.props.setModalValues({
            modal_open: 'rewards'
        })
    }
    handleLogout(){
        this.props.setValues({ doLogout: true })
    }
    render() {
        return (
            <MainContent className={"main main--" + (this.state.page==='join'?'1':this.props.userInfo.userProfile.team)}>
                <InGameMenu landingtoken={this.props.userInfo.lt}/>
                <div className={"main__warper main__warper--" + this.state.page}>
                    {this.state.page==='join' && 
                        <Choose
                            userDataRedux={this.props.userData}
                            loginUrlRedux={this.props.loginUrl}
                            allowJoin={this.state.allowJoin}
                            {...this.props.userInfo}
                            handleLogout={()=>this.handleLogout()}
                            handleJoin={(color)=>this.handleJoin(color)}
                            handleDetail={()=>this.handleDetail()}
                            handleReward={()=>this.handleReward()}
                        />
                    }
                    {this.state.page==='rank' && this.props.userData && 
                        <Rank
                            {...this.props.userInfo}
                            handleReward={()=>this.handleReward()}
                            handleDetail={()=>this.handleDetail()}
                            handleLogout={()=>this.handleLogout()}
                        />
                    }
                </div>
                <RuleModal/>
                <RewardsModal/>
                <MessageModal/>
                <LoadingModal/>
                <ConfirmModal
                    handleConfirm={()=>this.apiChoose()}
                />
                <SuccessModal
                    handleDetail={()=>this.handleDetail()}
                />
            </MainContent>
        );
    }
}

const mapStateToProps = state => ({
    ...state.Main,
    ...state.Modal
});

const mapDispatchToProps = { setValues, setModalValues };
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Home);

const MainContent = styled.div`
    position: relative;
    overflow: hidden;
    width: 100vw;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    .main{
        &__warper{
            position: relative;
            width: 100%;
            height: 100%;
            max-width: calc(100vh / 1080 * 1920 );
            max-height: calc(100vw / 1920 * 1080 );
            display: flex;
            align-items: center;
            flex-direction: column;
            z-index: 3;
            &--rank{
                max-width: unset;
            }
        }
    }
`;

